import styled, { css } from 'styled-components'
import { GridMixin, TransparentButton } from 'components/common/common_styles'
import { sizeMobile } from 'components/globalStyles'

export const MainContainer = styled.form`
  ${GridMixin};
  grid-template-columns: auto 1fr auto;
  align-items: center;
  width: 100%;
  padding: 16px 24px;
  background: white;
  color: var(--spBlack);
  position: relative;

  & > button:first-child {
    border-right: 1px solid #A19D9A;

    @media (max-width: ${sizeMobile}) {
      border-right: none;
      border-bottom: 1px solid #A19D9A;
      padding-bottom: 16px;
    }
  }

  @media (max-width: ${sizeMobile}) {
    grid-template-columns: 1fr;
    row-gap: 16px;
    width: fit-content;
    min-width: 70vw;
  }
`

export const DropdownButton = styled(TransparentButton)`
  white-space: nowrap;
  gap: 4px;
  font-size: 1.5rem;
  width: 100%;
  min-width: 18ch;
  display: flex;
  flex-direction: column;

  & > p:first-child {
    font-family: Garamond;
    font-size: 2rem;
    font-weight: 600;
    color: var(--spBlack);
  }

  @media (max-width: ${sizeMobile}) {
    gap: 0;
  }
`

export const GuestText = styled.p`
  position: relative;
  color: ${props => (props.disabled ? '#6C6762' : 'var(--spBlack)')};
  border: 1px solid transparent;
  ${props => props.error && css`
    border-color: #EE0000;
    padding: 0 6px;
    margin-left: -6px;
  `}
`

export const DateErrorText = styled.p`
  position: absolute;
  color: #EE0000;
  font-size: 1.2rem;
  left: 0px;
  bottom: -19px;
`

export const DialogBody = styled.p`
  white-space: pre-wrap;
`